/**
 * LE CONTRAT ANTI-ROBOTS — AB#884 (16 octobre 2026).
 *
 * Trois volets, un seul vocabulaire partagé par l'API, l'app et la console :
 *
 *   1. le DÉFI à l'entrée (Cloudflare Turnstile, sur le web seulement) : le
 *      jeton voyage dans le corps de la requête, sous `CHAMP_DEFI_ANTI_ROBOT` ;
 *   2. la LIMITE DE DÉBIT par compte sur les lectures du manuel ;
 *   3. la DÉTECTION d'un compte qui aspire le manuel, et son blocage temporaire.
 *
 * Ce fichier ne porte que des constantes et des formes : aucune logique.
 */
/** Le champ du corps qui porte le jeton Turnstile. L'API le retire avant de valider le corps. */
export const CHAMP_DEFI_ANTI_ROBOT = 'defiAntiRobot';
/** 403 — le défi est exigé (requête de navigateur) et le jeton manque ou est refusé. */
export const DEFI_ANTI_ROBOT_REFUSE_CODE = 'DEFI_ANTI_ROBOT_REFUSE';
/** 429 — trop de lectures du manuel en peu de temps, pour CE compte. */
export const LECTURE_TROP_RAPIDE_CODE = 'LECTURE_TROP_RAPIDE';
/** 429 — la lecture du contenu est suspendue pour ce compte, pour une durée. */
export const LECTURE_SUSPENDUE_CODE = 'LECTURE_SUSPENDUE';
/** Niveau d'un signalement d'aspiration. `blocage_simule` : le seuil de blocage atteint en mode « alerte ». */
export const NIVEAUX_SIGNALEMENT_LECTURE = ['alerte', 'blocage', 'blocage_simule'];
//# sourceMappingURL=anti-robots.js.map